import React, { useState } from "react"
import Modal from '../index'
import Button from "../../Form/Button"
import FormGroupInline from '../../Form/FormGroupInline'
import { MdOutlineContactPage } from "react-icons/md"
import SendMessage from "./Contents/SendMessage"
import AiInstructions from "./Contents/AiInstructions"
import AiResponse from "./Contents/AiResponse"
import AiConditional from "./Contents/AiConditional"
import CloseConversation from "./Contents/CloseConversation"
import TransferService from "./Contents/TransferService"

const ModalFlow = ({ node = [], onSubmit = () => { }, closeModal = () => { } }) => {
    const [data, setData] = useState(node?.data?.content || {})

    const handleChangeValue = (name, value) => {
        setData(previousValue => { return { ...previousValue, [name]: value } })
    }

    const handleCancel = (e) => {
        e.preventDefault()
        closeModal()
    }

    const handleSave = (e) => {
        e.preventDefault()
        onSubmit(node.id, data)
        closeModal()
    }

    const getContentByType = () => {
        switch (node.type) {
            case "sendMessage":
                return <SendMessage message={data} onChange={handleChangeValue} />
            case "aiInstructions":
                return <AiInstructions data={data} onChange={handleChangeValue} />
            case "aiResponse":
                return <AiResponse data={data} onChange={handleChangeValue} />
            case "aiConditional":
                return <AiConditional data={data} onChange={handleChangeValue} />
            case "closeConversation":
                return <CloseConversation data={data} onChange={handleChangeValue} />
            case "transferService":
                return <TransferService data={data} onChange={handleChangeValue} />
            default:
                break
        }
    }

    return (
        <Modal
            icon={<MdOutlineContactPage />}
            title={"Configurar"}
            description={"Preencha os campos abaixo e clique em salvar"}
            closeModal={closeModal}
        >
            <form onSubmit={(e) => e.preventDefault()}>
                {getContentByType()}
                <FormGroupInline>
                    <Button variant='primary' onClick={handleSave}>Salvar</Button>
                    <Button variant='secondary' onClick={handleCancel}>Cancelar</Button>
                </FormGroupInline>
            </form>
        </Modal>
    )
}

export default ModalFlow
